import styled from 'styled-components';

const ReviewCard = styled.div`
  padding-right: ${({ theme }) => theme.constants.lateralSpace};
  margin-bottom: 2vh;
`;

export default ReviewCard;
